
<!--begin::Footer-->
<div class="footer-wrap">
    <div class="footer py-6 d-flex flex-lg-column" id="kt_footer">
        <div class="offset-1 col-10">
            <!--begin::Container-->
            <div class="container-fluid">
                <!--begin::Copyright-->
                <div class="text-gray-900 order-2 order-md-1 link-row d-flex">
                    <span class="fw-semibold me-1">
                        <a href="https://mastervantagem.com/pt/">Master Vantagem</a>
                    </span>
                    <span class="fw-semibold me-1">{{ 'CONTACTS' | translate }}</span>
                    <span class="fw-semibold me-1">{{ 'FREQUENTLY_ASKED_QUESTIONS' | translate }}</span>
                    <span class="fw-semibold me-1">{{ 'CUSTOMER_SUPPORT' | translate }}</span>
                </div>

                <hr class="border-top border-success col-12">

                <div class="d-flex">
                    <div class="d-flex flex-column">
                        <span class="mb-2">{{ 'SOCIAL_MEDIA' | translate }}</span>
                        <div class="d-flex icon-row">
                            <div class="me-2">
                                <a href="https://www.linkedin.com/company/mastervantagemportugal/" target="_blank">
                                    <span class="fa-stack">
                                        <i class="fas fa-circle fa-stack-2x"></i>
                                        <i class="fab fa-linkedin-in fa-inverse fa-stack-1x text-white"></i>
                                    </span>
                                </a>
                                
                            </div>
                            <div class="me-2">
                                <a href="https://www.facebook.com/mastervantagem.pt" target="_blank">
                                    <span class="fa-stack">
                                        <i class="fas fa-circle fa-stack-2x"></i>
                                        <i class="fab fa-facebook-f fa-inverse fa-stack-1x text-white"></i>
                                    </span>
                                </a>
                            </div>
                            <div class="me-2">
                                <a href="https://www.instagram.com/mastervantagempt/" target="_blank">
                                    <span class="fa-stack">
                                        <i class="fas fa-circle fa-stack-2x"></i>
                                        <i class="fab fa-instagram fa-inverse fa-stack-1x text-white"></i>
                                    </span>
                                </a>
                                
                            </div>
                            
                        </div>
                    </div>
                    <div class="ms-auto">
                        <img src="/assets/images/Horizontal-verde 1.png">
                    </div>
                </div>
            </div>
            
        <!--end::Container-->
        </div>
    </div>
    <div class="py-6 d-flex flex-lg-column final-footer-row">
        <div class="offset-1 col-10">
            <div class="container-fluid d-flex">
                <span class="me-10 text-white"> {{ 'TERMS_AND_CONDITIONS' | translate }} </span>
                <span class="me-10 text-white"> {{ 'PRIVACY_POLICY' | translate }} </span>
                <span class="me-10 text-white"> {{ 'COMPLAINT_BOOK' | translate }} </span>
                <span class="me-10 text-white"> {{ 'CONFIGURE_COOKIES' | translate }}</span>
                <span class="ms-auto text-white"> &copy; 2024 {{ 'ALL_RIGHTS_RESERVED' | translate }} </span>
            </div>
        </div> 
    </div>
</div>
